import { Navigation } from "@/constants";
import { SimplePage } from "@/app/_/marketing/SimplePage";

export default function Page() {
  return (
    <SimplePage
      eyebrow="Solutions"
      title="Built for operators who outgrew spreadsheets."
      subtitle="Whether you run multiple entities, a finance team, or a growing small business, Neoledger scales with agentic workflows, triage, and configurable reporting."
      secondaryCta={{
        label: "Book a demo",
        to: Navigation.ROUTES.AUTH.WAITLIST,
      }}
      screenshot={{
        imageName: "multi-entity",
        alt: "Four businesses run from one workspace",
      }}
      bullets={Navigation.SOLUTION_ITEMS.map((item) => ({
        ReactIcon: item.ReactIcon,
        name: item.name,
        tagline: item.tagline,
        to: item.path,
      }))}
    />
  );
}
